/**
 * Questions of the contact form that are stored as custom deal fields in
 * Pipedrive. Single source of truth for:
 * - the form (labels and options),
 * - scripts/pipedrive-setup.mjs (creates the fields in Pipedrive),
 * - app/api/contact/route.js (maps the answers to the Pipedrive option ids).
 *
 * `name` is the custom field name in Pipedrive, the route finds the field by
 * this name, so do not rename it without renaming it in Pipedrive as well.
 * An option label must stay identical in Pipedrive and here.
 */
export const BRIEF_FIELDS = {
  projectType: {
    name: "Type de projet",
    question: "Quel type de projet avez-vous en tête ?",
    options: [
      "Un site web",
      "Une application web ou mobile",
      "Un outil métier ou interne",
      "Un audit d'une application créée avec l'IA (vibe coding)",
      "La refonte ou l'évolution d'un projet existant",
      "Autre / Je ne sais pas encore",
    ],
  },
  mainObjective: {
    name: "Objectif principal",
    question: "Quel est votre objectif principal ?",
    options: [
      "Gagner en visibilité",
      "Attirer de nouveaux clients",
      "Améliorer l'expérience des utilisateurs",
      "Simplifier ou automatiser des tâches",
      "Lancer un nouveau service",
      "Autre / À définir ensemble",
    ],
  },
  existing: {
    name: "Projet existant",
    question: "Partez-vous de quelque chose qui existe déjà ?",
    options: [
      "Oui, un site web",
      "Oui, une application ou un outil",
      "Non, c'est un nouveau projet",
    ],
  },
  advancement: {
    name: "Avancement",
    question: "Où en êtes-vous dans votre réflexion ?",
    options: [
      "J'ai une idée, mais rien de défini",
      "Je commence à préciser mes besoins",
      "J'ai un cahier des charges",
      "J'ai déjà des maquettes",
      "Mon projet est prêt à être lancé",
    ],
  },
  budget: {
    name: "Budget",
    question: "Avez-vous déjà une enveloppe budgétaire en tête ?",
    options: [
      "Moins de 5 000 €",
      "Entre 5 000 et 10 000 €",
      "Entre 10 000 et 20 000 €",
      "Entre 20 000 et 40 000 €",
      "Plus de 40 000 €",
      "Je ne sais pas encore",
    ],
  },
  deadline: {
    name: "Échéance",
    question: "Avez-vous une échéance en tête ?",
    options: [
      "Dès que possible",
      "Dans les 3 prochains mois",
      "Dans les 6 prochains mois",
      "Je n'ai pas de date précise",
    ],
  },
  contactPreference: {
    name: "Canal de contact préféré",
    question: "Comment préférez-vous être recontacté ?",
    options: ["E-mail", "Téléphone"],
  },
};
